import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f83e13be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-end tw-pt-[52px] tw-pr-[40px]" }
const _hoisted_2 = { class: "tw-p-10 main" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2 tw-mb-10" }
const _hoisted_4 = { class: "tw-font-semibold tw-text-[#211f58] tw-text-[25px] title-text" }
const _hoisted_5 = { class: "tw-flex action-mobile" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "tw-mt-[40px] tw-flex tw-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "tw-text-[#01893D] tw-text-[10px] tw-uppercase tw-not-italic tw-leading-[100%] tw-font-bold tw-tracking-[1px] tw-ml-[7.5px] tw-rounded-[21px] tw-bg-[#D9EDE2] tw-px-[6px] tw-px-[2px]"
}
const _hoisted_9 = { class: "tw-flex-1 tw-flex tw-justify-end show-more-notification" }
const _hoisted_10 = {
  key: 1,
  class: "tw-overflow-y-auto tw-mt-[30px] tw-pb-[40px] scroll-css"
}
const _hoisted_11 = {
  key: 2,
  class: "custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
}

import store from "../../store";
import utilities, { getComponentUiText } from "../../utils/utilities";
import { Ref, computed, onMounted, ref, watch } from "vue";
import searchInput from "../common/searchInput.vue";
import ButtonSort from "../common/setting/buttonSort.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import closeIcon from "@/components/svgs/closeIcon.vue";
import bellIcon from "@/components/svgs/bellIcon.vue";
import notificationBlocksUi from "./notificationBlock.vue";
import { IApiPromise } from "@/interfaces/responseData";
import get from "lodash/get";
import { UserRoute, Org } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import { getOrgIdProfile, getProfileImage } from "@/services/org";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

export default /*#__PURE__*/_defineComponent({
  __name: 'notification',
  props: {
  isNotificationNav: {
    type: Boolean,
    required: false,
  },
},
  emits: ["closeNotification"],
  setup(__props, { emit }) {

const props = __props;



// TODO: TEMPORARY
const filterOptions = [
  {
    id: 1,
    name: "app-notification-filter-option-1",
  },
  {
    id: 2,
    name: "app-notification-filter-option-1",
  },
  {
    id: 3,
    name: "app-notification-filter-option-1",
  },
  {
    id: 4,
    name: "app-notification-long-filter-option-1",
  },
];
const currentUser = computed(() => store.state.User.currentUser);
const notifications: any = computed(() =>
  store.state.Notification.notification.map((item: any) => {
    const name =
      item.checklistRequestedProviderName ||
      item.orgToOrgRequestOrg1Name ||
      item.orgToOrgOfferOrg1Name;

    const userImage = listAvatar.value.find(
      (avatar) =>
        avatar.orgId === item.orgToOrgOfferOrg1Id ||
        avatar.orgId === item.orgToOrgRequestOrg1Id,
    )?.avatarUrl;

    return {
      ...item,
      user: {
        companyName: currentUser.value.company || "",
        name: name || "",
        avatar: userImage || "",
      },
    };
  }),
);

let isAllNotificationOpen: Ref<boolean> = ref(true);
let searchText: Ref<string> = ref("");
let sortByAsc: Ref<boolean> = ref(false);

const loadingNotification = ref(true);
const filterOptionSelected = ref([]) as any;
const listAvatar: Ref<any[]> = ref([]);
const listProfile: Ref<any[]> = ref([]);

let notificationBlocks: any = computed(() => {
  let notificationTodayList = [] as any;
  let notificationYesterdayList = [] as any;
  let notificationThisWeekList = [] as any;
  let notificationThisMonthList = [] as any;
  let notificationOderList = [] as any;

  notifications.value.forEach((notification: any) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const notificationDate = new Date(notification.date_added);
    notificationDate.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    if (notificationDate.getTime() === today.getTime()) {
      notificationTodayList.push(notification);
    } else if (notificationDate.getTime() === yesterday.getTime()) {
      notificationYesterdayList.push(notification);
    } else if (notificationDate >= sevenDaysAgo) {
      notificationThisWeekList.push(notification);
    } else if (notificationDate >= thirtyDaysAgo) {
      notificationThisMonthList.push(notification);
    } else {
      notificationOderList.push(notification);
    }
  });

  let notificationBlocks = [
    {
      id: 1,
      title: "app-notification-today-block-1",
      notifications: notificationTodayList,
    },
    {
      id: 2,
      title: "app-notification-yesterday-block-1",
      notifications: notificationYesterdayList,
    },
    {
      id: 3,
      title: "app-notification-this-week-block-1",
      notifications: notificationThisWeekList,
    },
    {
      id: 4,
      title: "app-notification-this-month-block-1",
      notifications: notificationThisMonthList,
    },
    {
      id: 5,
      title: "app-notification-older-block-1",
      notifications: notificationOderList,
    },
  ];

  return notificationBlocks;
});

onMounted(() => {
  init();
});

watch(
  () => props.isNotificationNav,
  () => {
    if (props.isNotificationNav) {
      init();
    }
  },
);



const init = async () => {
  if (props.isNotificationNav) {
    loadingNotification.value = true;
    await store.dispatch("Notification/getNotification", {
      includeActioned: true,
    });
    await getListOrg();
    loadingNotification.value = false;
  }
};

const showConfirmModalDeleteAllNotifications = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-notification-modal-bulk-delete-option-title-1",
      ),
      description: getComponentUiText(
        "app-notification-modal-bulk-delete-option-description-1",
        false,
        {
          allText: {
            value: getComponentUiText(
              "app-notification-modal-bulk-delete-option-description-all-text-bold-1",
            ),
            css: "tw-text-[#231F20] tw-font-[600]",
          },
        },
      ),
      additionalNote: " ",
      buttonText: getComponentUiText(
        "app-notification-modal-bulk-delete-option-button-delete-1",
      ),
      buttonRed: true,
      modalContainerClass: "tw-z-[1101] tw-top-0",
    },
    events: {
      "update:data": deleteAllNotification,
    },
  };

  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const markAllAsReadNotification = async () => {
  await store.dispatch("Notification/markAllAsReadNotification");
};

const deleteAllNotification = async () => {
  await store.dispatch("Notification/deleteAllNotification");
};

const getListOrg = async () => {
  try {
    const orgIds = [
      ...new Set(
        notifications.value.map(
          (c) => c.orgToOrgOfferOrg1Id || c.orgToOrgRequestOrg1Id,
        ),
      ),
    ].filter((item) => item);

    await getOrgProfiles(orgIds);
    await getOrgAvatar();

    listAvatar.value = listAvatar.value.map((i) => {
      return {
        ...i,
        avatarUrl: URL.createObjectURL(
          utilities.base64ToFile(i.file, i.filename, i.fileType),
        ),
      };
    });
  } catch (error) {
    showErrorAPI(error, Org.getOrgProfile);
  }
};

const getOrgProfiles = async (orgIds: any[]) => {
  try {
    const listResult: any[] = [];
    const promise: IApiPromise<any>[] = [];
    orgIds.map((u) => promise.push(getOrgIdProfile(u)));

    const resArray = await Promise.allSettled(promise);
    resArray.forEach(
      (res) =>
        res.status === "fulfilled" &&
        listResult.push(get(res.value, "data.data", {})),
    );

    listProfile.value = listResult;
  } catch (error) {
    showErrorAPI(error, UserRoute.getUserProfile);
  }
};

const getOrgAvatar = async () => {
  const listResult: any[] = [];
  const promise: IApiPromise<any>[] = [];
  listProfile.value.map((u) =>
    promise.push(getProfileImage(u.avatar?.avatarImageFileId, u.orgId)),
  );

  const res = await Promise.allSettled(promise);
  res.forEach(
    (res) =>
      res.status === "fulfilled" &&
      listResult.push(get(res.value, "data.data", {})),
  );

  listAvatar.value = listResult;
};

const getNumberUnread = () => {
  const numberUnread = notifications.value.filter(
    (notification: any) => !notification.systemActionIsRead,
  );
  return numberUnread.length;
};

const getArrayUnread = (data) => {
  return data.filter((notification: any) => !notification.systemActionIsRead);
};

const sortNotificationBlock = (sortByAscValue: boolean) => {
  sortByAsc.value = sortByAscValue;

  const sortedBlocks = JSON.parse(JSON.stringify(notificationBlocks.value));

  sortedBlocks.sort((a, b) => {
    return sortByAscValue ? b.id - a.id : a.id - b.id;
  });

  notificationBlocks = ref(sortedBlocks);
};

const getDataFilter = (data: any) => {
  const dataKey = ["notes", "user.name"];
  const sortKey = "date_added";
  const filteredData: any[] = utilities.searchFilter(
    data,
    dataKey,
    searchText.value,
    sortByAsc.value,
    sortKey,
  );

  if (isAllNotificationOpen.value) {
    return filteredData;
  } else {
    return getArrayUnread(filteredData);
  }
};

const setIsAllNotificationOpen = (value) => {
  isAllNotificationOpen.value = value;
};

const emitCloseNotification = () => {
  emit("closeNotification");
};

const getOptionFilter = () => {
  return filterOptionSelected.value;
};

const onFilterOptionClick = (option: any) => {
  const duplicate = filterOptionSelected.value.filter(
    (item: any) => item.id === option.id,
  );
  if (duplicate && duplicate.length > 0) {
    return;
  }
  filterOptionSelected.value.push(option);
};

const removeOption = (option: any) => {
  filterOptionSelected.value = filterOptionSelected.value.filter(
    (item: any) => item.id !== option.id,
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`right-slider-notification ${__props.isNotificationNav ? 'expand' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(closeIcon, {
        size: 17,
        color: '#231F20',
        onClick: emitCloseNotification
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(bellIcon, {
          width: 17,
          height: 21,
          color: '#211F58'
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-notification-heading-1")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(searchInput, {
          modelValue: _unref(searchText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchText) ? (searchText).value = $event : searchText = $event)),
          "hint-text": 
            _unref(getComponentUiText)('app-prospect-questions-search-text-1')
          ,
          class: _normalizeClass('tw-mr-[20px]')
        }, null, 8, ["modelValue", "hint-text"]),
        _createVNode(ButtonSort, {
          active: true,
          "has-border": true,
          "id-popover": 'popover-btn-sort-notification'
        }, {
          default: _withCtx(() => [
            _createVNode(CustomDropDownItem, {
              style: 'normal',
              "id-text": 'app-notification-sort-date-1',
              "add-icon": true,
              "trans-form-rotate": 90,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortNotificationBlock(false)))
            }),
            _createVNode(CustomDropDownItem, {
              style: 'normal',
              "id-text": 'app-notification-sort-date-1',
              "add-icon": true,
              "trans-form-rotate": -90,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortNotificationBlock(true)))
            })
          ]),
          _: 1
        })
      ]),
      (getOptionFilter().length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOptionFilter(), (option) => {
              return (_openBlock(), _createElementBlock("span", {
                key: option.id,
                class: "tw-mt-[20px] tw-items-center tw-px-[13px] tw-py-[10px] tw-rounded-[100px] tw-border tw-border-[#211F58] tw-border-solid tw-text-[#211F58] tw-text-[11px] tw-font-medium tw-not-italic tw-leading-[130%] tw-inline-flex tw-mr-[10px]"
              }, [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(option.name)) + " ", 1),
                _createVNode(closeIcon, {
                  size: 8,
                  h: 8,
                  color: '#211F58',
                  x1: 7.11182,
                  y1: 1,
                  w1: 1.25702,
                  h1: 10.0561,
                  y2: 1.88672,
                  w2: 1.25702,
                  h2: 10.0561,
                  class: "tw-ml-[6px] tw-cursor-pointer",
                  onClick: ($event: any) => (removeOption(option))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "tw-inline-block tw-text-center tw-w-[38px] tw-cursor-pointer",
          onClick: _cache[3] || (_cache[3] = () => setIsAllNotificationOpen(true))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(`tw-text-[14px] ${
              _unref(isAllNotificationOpen) ? 'tw-text-[#387DFF]' : 'tw-text-[#231F20]'
            }  tw-font-medium tw-leading-[100%] tw-not-italic`)
          }, _toDisplayString(_unref(getComponentUiText)("app-notification-all-heading-option-block-1")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(`tw-h-[3px] tw-rounded-[5px] tw-w-[38px] tw-mt-[5px] ${
              _unref(isAllNotificationOpen) ? 'tw-bg-[#387DFF]' : ''
            }`)
          }, null, 2)
        ]),
        _createElementVNode("div", {
          class: "tw-inline-block tw-text-center tw-ml-[15px] tw-w-[100px] tw-cursor-pointer",
          onClick: _cache[4] || (_cache[4] = () => setIsAllNotificationOpen(false))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(`tw-text-[14px] ${
              !_unref(isAllNotificationOpen) ? 'tw-text-[#387DFF]' : 'tw-text-[#231F20]'
            } tw-font-medium tw-leading-[100%] tw-not-italic`)
          }, [
            _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-notification-unread-heading-option-block-1",
              )) + " ", 1),
            (getNumberUnread())
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getNumberUnread()), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`tw-h-[3px] tw-rounded-[5px] ${
              !_unref(isAllNotificationOpen) ? 'tw-bg-[#387DFF]' : ''
            }  tw-mt-[5px]`)
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(ButtonShowMore, {
            "id-popover": 'popover-btn-show-more-notification',
            "is-from-notification": true
          }, {
            default: _withCtx(() => [
              _createVNode(CustomDropDownItem, {
                style: 'normal',
                "id-text": "app-notification-mark-all-as-read-option-1",
                onClick: markAllAsReadNotification
              }),
              _createVNode(CustomDropDownItem, {
                style: 'danger',
                "id-text": "app-notification-delete-all-option-1",
                onClick: showConfirmModalDeleteAllNotifications
              })
            ]),
            _: 1
          })
        ])
      ]),
      (!loadingNotification.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationBlocks).filter(
            (block) => block.notifications.length,
          ), (block, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(notificationBlocksUi, {
                  data: getDataFilter(block.notifications),
                  title: block.title,
                  index: index,
                  "sort-asc": _unref(sortByAsc)
                }, null, 8, ["data", "title", "index", "sort-asc"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11))
    ])
  ], 2))
}
}

})